import "./LoadingCircle.scss"

export function LoadingCircle(props) {
    return <div className="lds-circle">
        <div></div>
    </div>
}